import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=7c29493e&scoped=true"
import script from "./ContactNotes.vue?vue&type=script&lang=js"
export * from "./ContactNotes.vue?vue&type=script&lang=js"
import style0 from "./ContactNotes.vue?vue&type=style&index=0&id=7c29493e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29493e",
  null
  
)

export default component.exports